import { render, staticRenderFns } from "./GatherInfo.vue?vue&type=template&id=476038a9&"
import script from "./GatherInfo.vue?vue&type=script&lang=js&"
export * from "./GatherInfo.vue?vue&type=script&lang=js&"
import style0 from "./GatherInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports